import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  PageIcon,
  PageDescription,
  ContentGrid,
  ContentRow,
  Card,
  CardTitle,
  CardContent,
  ActionBar,
  Button,
  SearchInput,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  formatDate,
  fadeIn,
  ButtonSuccess
} from '../styles/PageStyles';
import { fetchKnowledgeBaseByPagination, fetchKnowledgeBaseCount, getKnowledgeBases } from '../services/knowledgeBaseService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLandmark, faPlus } from '@fortawesome/free-solid-svg-icons';
import { fetchEntityCount } from '../services/entityService';
import Pagination from '../components/common/Pagination';

const KnowledgeBase = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [kbList, setKbList] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;


  useEffect(() => {
    const fetchKbData = async () => {
      try {
        const response = await fetchKnowledgeBaseByPagination(( currentPage - 1) * itemsPerPage, itemsPerPage) 
        setKbList(response.filter(item => (item.name && item.name.trim() !== '')) || []);
      } catch (error) {
        console.error('Error fetching user data:', error);
        navigate('/login'); // Redirect to login if unauthorized
      }
    };

    fetchKbData();
  }, [navigate, setKbList, currentPage]);

  useEffect(() => {
    const getKnowledgeBaseCount = async () => {
      const count = await fetchKnowledgeBaseCount();
      setTotalItems(count);
    }

    getKnowledgeBaseCount();
  }, [])

  // Filter documents based on search term
  const filteredKb = (kbList || []).filter(kb =>
    kb.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
    kb.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    kb.description.toLowerCase().includes(searchTerm.toLowerCase())
  );
  // Handle view claim details
  const handleViewKb = (knowledgebaseId) => {
    navigate(`/knowledge-base-details/${knowledgebaseId}`);
  };
  const handleQueryKb = (knowledgebaseId) => {
    navigate(`/knowledge-base-query/${knowledgebaseId}`);
  };

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'active';
      case 'connected': return 'active';
      case 'archived': return 'default';
      case 'disconnected': return 'error';
      default: return 'default';
    }
  };

  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeaderWithInfo
          icon={faLandmark}
          title="Knowledge Base"
          description="Manage the knowledge sources that power your AI agents. Upload documents, connect to external data sources, and organize information to ensure your agents have access to accurate and up-to-date information."
        >
          <SearchInput
            type="text"
            placeholder="Search Knowledge Base"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <ButtonSuccess style={{marginLeft:"10px"}} onClick={() => handleViewKb('new')} primary><FontAwesomeIcon icon={faPlus} /> Knowledgebase</ButtonSuccess>
        </PageHeaderWithInfo>

        {/* <ActionBar>
          <SearchInput
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button>Filter</Button>
          <Button>Sort</Button>
        </ActionBar> */}

        <Card>
          <Table>
            <thead>
              <tr>
                <TableHeader>Name</TableHeader>
                <TableHeader>Description</TableHeader>
                <TableHeader>Last Updated </TableHeader>
                <TableHeader>Actions</TableHeader>
              </tr>
            </thead>
            <tbody>
              {filteredKb.map((kb, index) => (
                <TableRow key={index}>
                  <TableCell>{kb.name}</TableCell>
                  <TableCell>{kb.description}</TableCell>
                  <TableCell>{formatDate(kb.updated_at)}</TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => handleViewKb(kb.code)}>Edit</Button>
                      <Button primary style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => handleQueryKb(kb.code)}>Query</Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </tbody>
          </Table>
        </Card>

        {/* <Card style={{ marginTop: '2rem' }}>
          <CardTitle>Knowledge Integration</CardTitle>
          <CardContent>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  fontSize: '1.5rem'
                }}>
                  1
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Import</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Upload documents or connect to external sources</p>
              </div>

              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  fontSize: '1.5rem'
                }}>
                  2
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Process</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Extract, index, and structure information</p>
              </div>

              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  fontSize: '1.5rem'
                }}>
                  3
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Validate</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Verify accuracy and resolve conflicts</p>
              </div>

              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  fontSize: '1.5rem'
                }}>
                  4
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Deploy</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Make knowledge available to AI agents</p>
              </div>
            </div>
          </CardContent>
        </Card> */}

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalItems}
          setCurrentPage={setCurrentPage}
          setTotalPages={setTotalPages}
        />
      </motion.div>
    </PageContainer>
  );
};

export default KnowledgeBase;
